// id strings for messages/home.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const home: Dict = {
  "home.seo.title": "Jammable | Bikin Cover AI dengan Suara Favoritmu!",
  "home.seo.description":
    "Bikin cover AI dalam hitungan detik dengan Jammable. Ribuan model suara AI yang diupload komunitas siap kamu pakai untuk berkarya!",
  "home.seo.ogTitle":
    "Jammable | Bikin Cover AI dengan Suara Favoritmu | Kreasi Musik dengan AI",
  "home.seo.imageAlt": "Jammable - Bikin Cover AI",

  // Hero: "Buat <highlight>cover AI</highlight> dengan suara favoritmu".
  "home.hero.views": "10 miliar+ penayangan di TikTok, YouTube, dan Instagram",
  "home.hero.titleBefore": "Bikin",
  "home.hero.titleHighlight": "cover AI",
  "home.hero.titleAfter": "dengan suara favoritmu",
  "home.hero.subtitle":
    "Pilih dari 100.000+ suara AI, tambahkan audiomu, dan hasilnya jadi dalam hitungan detik.",
  "home.hero.decorVoice": "suara AI",
  "home.hero.decorCover": "cover",
  "home.hero.searchLabel": "Cari suara",
  "home.hero.searchPlaceholder": "Cari di 100.000+ suara",
  "home.hero.searchButton": "Cari",
  "home.hero.makeCover": "Buat cover",

  "home.categories.all": "Lihat semua kategori",
  "home.recent": "Lanjutkan lagi",
  "home.trending": "Lagi trending",
  "home.seeAll": "Lihat semua",

  // "Latih sendiri <highlight>suara AI-mu</highlight>"
  "home.train.kicker": "100.000+ suara berawal dari sini",
  "home.train.titleBefore": "Latih sendiri",
  "home.train.titleHighlight": "suara AI-mu",
  "home.train.body":
    "Bikin suara dari beberapa sampel, lalu buat cover dengan suara yang tidak dimiliki orang lain.",
  "home.train.step1": "Upload sampelmu",
  "home.train.step1Sub": "Cukup klip pendek berisi vokal yang jernih",
  "home.train.step2": "Kami latih modelmu",
  "home.train.step2Sub": "Suara kustommu siap dalam hitungan menit",
  "home.train.step3": "Bikin cover dengannya",
  "home.train.step3Sub": "Pakai di covermu, kapan pun kamu mau",

  "home.topCollections": "Koleksi teratas",
  "home.collabs": "Kolaborasi trending",
  "home.collection": "Koleksi",

  // Cards (components/home/JamCards.tsx)
  "home.card.uses": "{n} kali dipakai",
  "home.card.voices": "{n} suara",
  "home.card.likes": "{n} suka",
  "home.card.by": "oleh @{user}",
  "home.card.madeToday": "{n} dibuat hari ini",
  "home.card.makeDuet": "Buat duet ini",

  // Discord CTA (components/DiscordCta.js)
  "home.discord.bannerSub":
    "Bagikan cover, request suara, dan dapatkan bantuan dari komunitas",
  "home.discord.online": "{n} online",
  "home.discord.members": "{n} anggota",
  "home.discord.joinDiscord": "Gabung Discord",
  "home.discord.softSub": "Bagikan cover, request suara, dapatkan tips",
  "home.discord.cardSub": "Dapatkan bantuan, bagikan cover, temukan suara baru",
  "home.discord.join": "Gabung",
};

export default home;
